var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailedIcon = function SvgFailedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.753,
    height: 79.753,
    viewBox: "0 0 79.753 79.753"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.a,.d{stroke:#171926;}.b{fill:#16b6bf;}.c{clip-path:url(#a);}.d{fill:none;stroke-width:2px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 14,
    height: 14,
    transform: "translate(0.225 0.225)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-199 -356)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(199 356)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 34,
    height: 5,
    transform: "translate(23 73)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.766,64H65.132a1.329,1.329,0,1,0,0,2.658H75.766a1.329,1.329,0,0,1,1.329,1.329v38.547H2.658V67.988a1.329,1.329,0,0,1,1.329-1.329h9.3a1.329,1.329,0,1,0,0-2.658h-9.3A3.988,3.988,0,0,0,0,67.988v45.193a3.988,3.988,0,0,0,3.988,3.988H34.56v7.975H23.926a1.329,1.329,0,0,0-1.19.735L20.078,131.2a1.329,1.329,0,0,0,1.19,1.923H58.486a1.329,1.329,0,0,0,1.2-1.923l-2.658-5.317a1.329,1.329,0,0,0-1.2-.735H45.193v-7.975H75.766a3.988,3.988,0,0,0,3.988-3.988V67.988A3.988,3.988,0,0,0,75.766,64Zm-20.76,63.8,1.329,2.658H23.418l1.329-2.658Zm-17.788-2.658v-7.975h5.317v7.975Zm39.877-11.963a1.329,1.329,0,0,1-1.329,1.329H3.988a1.329,1.329,0,0,1-1.329-1.329v-3.988H77.095Z",
    transform: "translate(0 -64)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.255,0A25.255,25.255,0,1,0,138.51,25.255,25.255,25.255,0,0,0,113.255,0Zm0,47.852a22.6,22.6,0,1,1,22.6-22.6A22.6,22.6,0,0,1,113.255,47.852Z",
    transform: "translate(-88)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.889 57.156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.646,344h-5.317a1.329,1.329,0,0,0,0,2.658h5.317a1.329,1.329,0,0,0,0-2.658Z",
    transform: "translate(-216 -344)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-350.124 -172.923)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20,40A20.005,20.005,0,0,1,12.215,1.572a20.005,20.005,0,0,1,15.57,36.857A19.874,19.874,0,0,1,20,40ZM20,4.652a15.348,15.348,0,0,0-10.853,26.2A15.348,15.348,0,1,0,30.853,9.147,15.248,15.248,0,0,0,20,4.652Z",
    transform: "translate(370.123 178.123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.088,28A21.088,21.088,0,1,0,42.176,49.088,21.088,21.088,0,0,0,21.088,28ZM35.074,61.32l-1.753-1.753a16.039,16.039,0,0,0,3.83-9.238h2.481A18.5,18.5,0,0,1,35.074,61.32ZM2.544,50.328H5.025a16.039,16.039,0,0,0,3.83,9.238L7.1,61.32A18.5,18.5,0,0,1,2.544,50.328ZM7.1,36.856l1.753,1.753a16.039,16.039,0,0,0-3.83,9.238H2.544A18.5,18.5,0,0,1,7.1,36.856ZM21.088,62.733A13.645,13.645,0,1,1,34.733,49.088,13.645,13.645,0,0,1,21.088,62.733ZM31.567,36.855a16.039,16.039,0,0,0-9.238-3.83V30.544A18.5,18.5,0,0,1,33.32,35.1Zm-11.719-3.83a16.039,16.039,0,0,0-9.238,3.83L8.856,35.1a18.5,18.5,0,0,1,10.992-4.558Zm-9.238,28.3a16.039,16.039,0,0,0,9.238,3.83v2.481A18.5,18.5,0,0,1,8.856,63.074Zm11.719,3.83a16.039,16.039,0,0,0,9.238-3.83l1.753,1.753a18.5,18.5,0,0,1-10.992,4.558Zm14.823-17.3a16.039,16.039,0,0,0-3.83-9.238l1.753-1.753a18.5,18.5,0,0,1,4.558,10.992Z",
    transform: "translate(369 148.923)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(231.652 373.268)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.887 1.887)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-23457-22296l10.676,10.674",
    transform: "translate(23457 22296.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-23457-22285.328l10.676-10.674",
    transform: "translate(23457 22296.002)"
  }))))));
};
export default SvgFailedIcon;